/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { ChatRequest } from '../models/ChatRequest';
import type { ChatResponse } from '../models/ChatResponse';
import type { ConversationHistoryResponse } from '../models/ConversationHistoryResponse';
import type { GetConversationHistoryRequest } from '../models/GetConversationHistoryRequest';
import type { IngestTextRequest } from '../models/IngestTextRequest';
import type { IngestWebsiteRequest } from '../models/IngestWebsiteRequest';
import type { PlanComparisonRequest } from '../models/PlanComparisonRequest';
import type { PlanDeepDiveRequest } from '../models/PlanDeepDiveRequest';
import type { PlanHighlightsRequest } from '../models/PlanHighlightsRequest';
import type { PlanHighlightsResponse } from '../models/PlanHighlightsResponse';
import type { ResumeConversationRequest } from '../models/ResumeConversationRequest';

export class DefaultService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Chat with the assistant
   * Send a user message and conversation ID to receive a full response from the assistant.
   * @param employeeId
   * @param onboardingPeriodId ID of the onboarding period
   * @param requestBody
   * @param zorroCorrelationId
   * @returns ChatResponse Successful Response
   * @throws ApiError
   */
  public chat(
    employeeId: string,
    onboardingPeriodId: string,
    requestBody: ChatRequest,
    zorroCorrelationId?: string | null
  ): CancelablePromise<ChatResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employees/{employeeId}/onboarding-periods/{onboardingPeriodId}/chat',
      path: {
        employeeId: employeeId,
        onboardingPeriodId: onboardingPeriodId,
      },
      headers: {
        'zorro-correlation-id': zorroCorrelationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Chat with the assistant - experimental SSE streaming
   * Send a user message and conversation ID to receive a streaming response from the assistant.
   * @param employeeId
   * @param onboardingPeriodId ID of the onboarding period
   * @param requestBody
   * @param zorroCorrelationId
   * @returns string Successful Response
   * @throws ApiError
   */
  public chatStream(
    employeeId: string,
    onboardingPeriodId: string,
    requestBody: ChatRequest,
    zorroCorrelationId?: string | null
  ): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employees/{employeeId}/onboarding-periods/{onboardingPeriodId}/chat_stream_sse',
      path: {
        employeeId: employeeId,
        onboardingPeriodId: onboardingPeriodId,
      },
      headers: {
        'zorro-correlation-id': zorroCorrelationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Chat with the assistant
   * Send a user message and conversation ID to receive a streaming response from the assistant.
   * @param employeeId
   * @param onboardingPeriodId ID of the onboarding period
   * @param requestBody
   * @param zorroCorrelationId
   * @returns string Successful Response
   * @throws ApiError
   */
  public chatStream1(
    employeeId: string,
    onboardingPeriodId: string,
    requestBody: ChatRequest,
    zorroCorrelationId?: string | null
  ): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employees/{employeeId}/onboarding-periods/{onboardingPeriodId}/chat_stream',
      path: {
        employeeId: employeeId,
        onboardingPeriodId: onboardingPeriodId,
      },
      headers: {
        'zorro-correlation-id': zorroCorrelationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get conversation history
   * Retrieve all conversation history messages for a given onboarding period.
   * @param employeeId ID of the employee
   * @param onboardingPeriodId ID of the onboarding period
   * @param zorroCorrelationId
   * @returns ConversationHistoryResponse Successful Response
   * @throws ApiError
   */
  public getConversationHistory(
    employeeId: string,
    onboardingPeriodId: string,
    zorroCorrelationId?: string | null
  ): CancelablePromise<ConversationHistoryResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/employees/{employeeId}/onboarding-periods/{onboardingPeriodId}/conversation-history',
      path: {
        employeeId: employeeId,
        onboardingPeriodId: onboardingPeriodId,
      },
      headers: {
        'zorro-correlation-id': zorroCorrelationId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Add resume message
   * Add a new resume previous conversation to the history so the user can resume deep dive or compare plans workflows
   * @param onboardingPeriodId
   * @param requestBody
   * @returns any Successful Response
   * @throws ApiError
   */
  public addResumeConversationMessage(
    onboardingPeriodId: string,
    requestBody: ResumeConversationRequest
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employees/{employeeId}/onboarding-periods/{onboardingPeriodId}/add-resume-conversation-message',
      path: {
        onboardingPeriodId: onboardingPeriodId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Ingest a single text document
   * Ingest a single text document into the vector database.
   * @param requestBody
   * @returns any Successful Response
   * @throws ApiError
   */
  public ingestText(
    requestBody: IngestTextRequest
  ): CancelablePromise<Record<string, any>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/ingest/text',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Ingest an entire website
   * Crawl and ingest content from a website into the vector database.
   * @param requestBody
   * @returns any Successful Response
   * @throws ApiError
   */
  public ingestWebsite(
    requestBody: IngestWebsiteRequest
  ): CancelablePromise<Record<string, any>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/ingest/website',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Ingest Intercom articles
   * Ingest all articles from Intercom into the vector database.
   * @returns any Successful Response
   * @throws ApiError
   */
  public ingestIntercom(): CancelablePromise<Record<string, any>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/ingest/intercom',
    });
  }
  /**
   * Run Plan Deep Dive Agent
   * Run the plan deep dive agent with a user query and plan data.
   * @param employeeId
   * @param onboardingPeriodId ID of the onboarding period
   * @param requestBody
   * @param zorroCorrelationId
   * @returns ChatResponse Successful Response
   * @throws ApiError
   */
  public planDeepDive(
    employeeId: string,
    onboardingPeriodId: string,
    requestBody: PlanDeepDiveRequest,
    zorroCorrelationId?: string | null
  ): CancelablePromise<ChatResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employees/{employeeId}/onboarding-periods/{onboardingPeriodId}/plan_deep_dive',
      path: {
        employeeId: employeeId,
        onboardingPeriodId: onboardingPeriodId,
      },
      headers: {
        'zorro-correlation-id': zorroCorrelationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get conversation history for deep dive conversations
   * Retrieve all conversation history messages for a given deep dive conversation
   * @param employeeId ID of the employee
   * @param onboardingPeriodId ID of the onboarding period
   * @param requestBody
   * @returns ConversationHistoryResponse Successful Response
   * @throws ApiError
   */
  public getDeepDiveConversationHistory(
    employeeId: string,
    onboardingPeriodId: string,
    requestBody: GetConversationHistoryRequest
  ): CancelablePromise<ConversationHistoryResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employees/{employeeId}/onboarding-periods/{onboardingPeriodId}/deep-dive-conversation-history',
      path: {
        employeeId: employeeId,
        onboardingPeriodId: onboardingPeriodId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Run Plan Comparison Agent
   * Run the plan comparison agent with a user query and a list of plans.
   * @param employeeId
   * @param onboardingPeriodId ID of the onboarding period
   * @param requestBody
   * @param zorroCorrelationId
   * @returns ChatResponse Successful Response
   * @throws ApiError
   */
  public planComparison(
    employeeId: string,
    onboardingPeriodId: string,
    requestBody: PlanComparisonRequest,
    zorroCorrelationId?: string | null
  ): CancelablePromise<ChatResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employees/{employeeId}/onboarding-periods/{onboardingPeriodId}/plan_comparison',
      path: {
        employeeId: employeeId,
        onboardingPeriodId: onboardingPeriodId,
      },
      headers: {
        'zorro-correlation-id': zorroCorrelationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get conversation history for plan comparison conversations
   * Retrieve all conversation history messages for a given plan comparison conversation
   * @param employeeId ID of the employee
   * @param onboardingPeriodId ID of the onboarding period
   * @param requestBody
   * @returns ConversationHistoryResponse Successful Response
   * @throws ApiError
   */
  public getPlanComparisonConversationHistory(
    employeeId: string,
    onboardingPeriodId: string,
    requestBody: GetConversationHistoryRequest
  ): CancelablePromise<ConversationHistoryResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employees/{employeeId}/onboarding-periods/{onboardingPeriodId}/plan-comparison-conversation-history',
      path: {
        employeeId: employeeId,
        onboardingPeriodId: onboardingPeriodId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Generate Plan Highlights
   * Generate highlights for a selected plan using the plan highlights agent.
   * @param employeeId ID of the employee
   * @param onboardingPeriodId ID of the onboarding period
   * @param requestBody
   * @param zorroCorrelationId
   * @returns PlanHighlightsResponse Successful Response
   * @throws ApiError
   */
  public planHighlights(
    employeeId: string,
    onboardingPeriodId: string,
    requestBody: PlanHighlightsRequest,
    zorroCorrelationId?: string | null
  ): CancelablePromise<PlanHighlightsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/employees/{employeeId}/onboarding-periods/{onboardingPeriodId}/plan_highlights',
      path: {
        employeeId: employeeId,
        onboardingPeriodId: onboardingPeriodId,
      },
      headers: {
        'zorro-correlation-id': zorroCorrelationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
